import { tryPromise } from "../../base/cutil/LangUtil";
import isBlank from "@sedan-utils/is-blank";
export class HomeUtil {
    static async getObjectData(brainClient, attrIndexer) {
        const params = { attrIndexer };
        const res = await tryPromise(brainClient.graphql.objectSetRace(params));
        if (res.error) {
            console.log("res.error", res.error);
            throw "Get template failed";
        }
        if (!res.data?.data || isBlank(res.data.data)) {
            throw "data was empty";
        }
        const data = res.data.data;
        if (!data.getByAttrIndexer || isBlank(data.getByAttrIndexer)) {
            throw "getByAttrIndexer was empty";
        }
        const getByIndexerData = data.getByAttrIndexer.objectSet;
        if (!data.getByUUID || isBlank(data.getByUUID)) {
            throw "getByUUID was empty";
        }
        const getByUUidData = data.getByUUID.objectSet;
        const objectData = isBlank(getByIndexerData) ? getByUUidData : getByIndexerData;
        if (isBlank(objectData)) {
            console.log("objectSetRace result error");
            throw "Get template objectSet failed";
        }
        return objectData;
    }
}
